import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ArrowForwardIconProps extends SvgIconProps {}

export const ArrowForwardIcon = (
  props: ArrowForwardIconProps,
): ReactElement => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 25">
      <mask
        id="mask0_1256_6818"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1256_6818)">
        <path
          d="M8.00588 21.8079L6.94238 20.7444L15.1866 12.5001L6.94238 4.25588L8.00588 3.19238L17.3136 12.5001L8.00588 21.8079Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
